import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';

export const useEditMode = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const { isAuthenticated, isAdmin } = useAuth();

  // Activer automatiquement le mode édition quand l'admin est connecté
  useEffect(() => {
    if (isAuthenticated && isAdmin) {
      setIsEditMode(true);
      sessionStorage.setItem('editMode', 'true');
    } else {
      setIsEditMode(false);
      sessionStorage.removeItem('editMode');
    }
  }, [isAuthenticated, isAdmin]);

  const toggleEditMode = () => {
    if (isAuthenticated && isAdmin) {
      const newMode = !isEditMode;
      setIsEditMode(newMode);
      sessionStorage.setItem('editMode', String(newMode));
    }
  };

  return { 
    isEditMode, 
    toggleEditMode
  };
};